import type { RouteLocationNormalized } from 'vue-router'
import { includes, isArray, some, startsWith } from 'lodash'
import { HELM_QUERY_KEYS } from '@helm/constants/query'
import useHelmApi from '@helm/composables/helmApi'
import queryClient from '@helm/plugins/query'

export default async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    const { api, isLoggedIn } = useHelmApi()
    const bypass = !isLoggedIn.value || to.name === 'login' || to.name === 'logout'

    if (to.meta.roles && !bypass) {
        const data = await queryClient.ensureQueryData({
            queryKey: HELM_QUERY_KEYS.me,
            queryFn: () => api.authentication.getLoggedInUser().then(({ data }) => data)
        })
        const desiredRoles = isArray(to.meta.roles) ? to.meta.roles : [to.meta.roles]
        const actualRoles = data?.permissions ?? []

        // Check if user has ANY of the features enabled for the route
        // also check for optional negation "!" prefix to exclude a feature
        const hasRole = some(desiredRoles, (role: string) =>
            startsWith(role, '!') ? !includes(actualRoles, role.slice(1)) : includes(actualRoles, role)
        )

        if (!hasRole) {
            //console.log('Permission denied', desiredRoles, 'not in', actualRoles, data)
            return from
        }
    }
}
